export class CustomDeliveryDateDTI {
  deliveriesToInsert?: CustomDeliveriesToInsert[];
  deliveriesToUpdate?: CustomDeliveriesToUpdate[];
  deliveryIdsToDelete?: number[];
  constructor(init?: CustomDeliveryDateDTI) {
    Object.assign(this, init);
  }
}

export class OrderItemDeliveryDTO {
  customDeliveryDate: string;
  quantity: number;
  id?: number;
  erpQuantity?: number;
  erpCancelledQuantity?: number;
  externalId?: string;
  erpDeliveryDate?: string;
  constructor(init?: OrderItemDeliveryDTO) {
    Object.assign(this, init);
  }
}

export class CustomDeliveriesToInsert {
  customDeliveryDate: string;
  quantity: number;
  constructor(init?: CustomDeliveriesToInsert) {
    Object.assign(this, init);
  }
}

export class CustomDeliveriesToUpdate extends CustomDeliveriesToInsert {
  id: number;
  constructor(init?: CustomDeliveriesToUpdate) {
    super();
    Object.assign(this, init);
  }
}

export class CustomDeliveryDateVM {
  orderItemId: number;
  variantId: number;
  deliveries: CustomDeliveryDateDTI;
  constructor(init?: CustomDeliveryDateVM) {
    Object.assign(this, init);
  }
}

export interface OrderItemFormVM {
  isChecked: boolean;
  date: string;
  img: string;
  size: string;
  color: string;
  qty: number;
  status: StatusOrderItemFormVm;
  variantId: number;
  orderItemId: number;
  customDates: CustomDateVM[];
}

export interface StatusOrderItemFormVm {
  status: number;
  badgeColor: number;
  label: string;
}

export interface CustomDateVM {
  date: string;
  qty: number;
  id: number;
}
